import React from "react";
import PropTypes from "prop-types";
import './Breadcrumb.scss';

function Breadcrumb(props) {
	const lastItemIndex = props.items.length - 1;
	const breadcrumbItems = props.items.map((item, index) => {
		if (!item) return null;
		return <li className={`breadcrumb-item ${index === lastItemIndex ? 'active' : ''}`} key={index}>{item}</li>
	});

	return (
		<h3 className="mb-3">
			<nav aria-label="breadcrumb">
				<ol className="breadcrumb">
					{breadcrumbItems}
				</ol>
			</nav>
		</h3>
	)
}

Breadcrumb.propTypes = {
	items: PropTypes.array.isRequired
}

export default Breadcrumb;
